import { FaHeadset, FaCommentDots } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardChamado = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.chamado_info;

    if (!info) return null;

    const isResposta = info.mensagem_resposta;
    
    let titulo, descricao, icon, color, text, label;

    if (isResposta) {
        titulo = `Nova resposta no chamado #${info.numero}`;
        descricao = "Houve uma nova interação. Clique para responder.";
        icon = <FaCommentDots />;
        color = "info";
        text = "text-info";
        label = "Resposta Chamado";
    } else {
        titulo = `Novo chamado #${info.numero} aberto`;
        descricao = `Aberto por: ${info.solicitante_nome}`;
        icon = <FaHeadset />;
        color = "success";
        text = "text-success";
        label = "Novo Chamado";
    }

    let dataDisplay = notif.data_criacao || "-";

    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
             dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {}
    }

    const handleClick = () => {
        navigate(`/chamados/edit/${info.id}`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={icon}
            color={color}
            text={text}
            label={label}
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardChamado;
